export default "__VITE_ASSET__23a056f8__"